export default __webpack_public_path__ + "static/media/icon-incorrect-name.ce4ac249.svg";